import { enhancementPointProperty } from "../../property/resource/enhancement-point-property";
import { ResourceColumn } from "../planner-column";

export const enhancementPointColumn = new ResourceColumn(
  'Enhancement Points',
  'enhcropped.png',
  'enhancementPoints',
  enhancementPointProperty,
)
